import { render, staticRenderFns } from "./SearchSelectSavedFilters.vue?vue&type=template&id=12e86352&"
import script from "./SearchSelectSavedFilters.vue?vue&type=script&lang=ts&"
export * from "./SearchSelectSavedFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports